export default __webpack_public_path__ + "static/media/rubber-insulation.df8515b6.jpg";